import React, {
  useState,
  useEffect,
  componentDidMount,
  useCallback
} from "react";
import { Bar } from "react-chartjs-2";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row
} from "reactstrap";
import { Client, Account, Databases, Query } from "appwrite";
import { Link, useNavigate } from "react-router-dom";
import getFrenchTag from "../../helpers/local_text_helper";
import Flatpickr from "react-flatpickr";
import ReactApexChart from "react-apexcharts";
import { withTranslation } from "react-i18next";
import logo_maaia from "../../assets/images/companies/img-3.png";
import global_view from "../../assets/images/global_view.png";

const option = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    dataset: [
      {
        display: false,
        gridLines: {
          drawBorder: false,
          offset: true
        },
        ticks: {
          fontColor: "#686868"
        }
      }
    ],
    dataset1: [
      {
        barPercentage: 0.7,
        categoryPercentage: 0.5,

        ticks: {
          fontColor: "#7b919e"
        },
        gridLines: {
          display: false,
          drawBorder: false
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    ]
  }
};

const VueGlobale = (props) => {
  const dataMap = new Map();
  const [statsData, setStatsData] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [hoverText, setHoverText] = useState([]);

  function convertDate(milliseconds) {
    const date = new Date(milliseconds);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const dateFormated = `${day}/${month}/${year}`;
    return dateFormated;
  }
  const theStatistics = props.statistics;
  const latestStatistic = props.statistics[0];
  const theMessages = props.messages;

  const handleDateChange = (dates) => {
    if (dates.length === 2) {
      const startDate = dates[0];
      const endDate = dates[1];

      const timeDifference = endDate.getTime() - startDate.getTime();

      const millisecondsInADay = 24 * 60 * 60 * 1000;
      const daysDifference = Math.floor(timeDifference / millisecondsInADay);

      console.log("Durée en jours:", daysDifference);
      if (daysDifference > 12) {
        console.log("On affiche en mois");
      } else if (daysDifference > 30) {
        console.log("On affiche en Années");
      }
    }
  };
  const getMessageData = (theData) => {
    if (theData && theData.length) {
      var latestData = theData[0];

      const total =
        latestData.traited_mail_count + latestData.untraited_mail_count || 1;
      dataMap.set(
        "message_total",
        latestData.traited_mail_count + latestData.untraited_mail_count === 0
          ? 0
          : (total * 100) / total
      );
      dataMap.set(
        "auth_total",
        (latestData.authorized_mail_count * 100) / total
      );
      dataMap.set(
        "treated_total",
        (latestData.traited_mail_count * 100) /
          (latestData.authorized_mail_count || 1)
      );
      dataMap.set(
        "untreated_total",
        (latestData.untraited_mail_count * 100) /
          (latestData.authorized_mail_count || 1)
      );
    } else {
      dataMap.set("message_total", 0);
      dataMap.set("auth_total", 0);
      dataMap.set("treated_total", 0);
      dataMap.set("untreated_total", 0);
    }
    console.log("dataMap is", dataMap);

    setStatsData(dataMap);

    setLoading(false);
  };

  const getItemData = (item_key, the_statsData) => {
    switch (item_key) {
      case "message_total":
        return {
          text: "Messages reçus",
          width: the_statsData ? the_statsData.get(item_key) : 1,
          backgroundColor: "#FF7049"
        };
      case "auth_total":
        return {
          text: "E-mails autorisés",
          width: the_statsData ? the_statsData.get(item_key) : 1,
          backgroundColor: "#563BFF"
        };
      case "treated_total":
        return {
          text: "Répondus par Synibox",
          width: the_statsData ? the_statsData.get(item_key) : 1,
          backgroundColor: "#FFA412"
        };
      case "untreated_total":
        return {
          text: "Transférés à l'Humain",
          width: the_statsData ? the_statsData.get(item_key) : 1,
          backgroundColor: "#F10944"
        };
      default:
        return {
          text: "En attente",
          width: the_statsData ? the_statsData.get(item_key) : 1,
          backgroundColor: "#329993"
        };
    }
  };

  const handleIconMouseEnter = (value, text) => {
    setHoverText([value, text]);
  };
  const handleIconMouseLeave = () => {
    setHoverText("");
  };

  useEffect(() => {
    getMessageData(theStatistics);
  }, [theStatistics]);

  const svgs = {
    info_icon: (
      <svg
        fill="currentColor"
        width="30"
        height="auto"
        viewBox="-1920 -1920 5760.00 5760.00"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" style={{ strokeWidth: "0" }} />

        <g
          id="SVGRepo_tracerCarrier"
          style={{ strokeLinecap: "round", strokeLinejoin: "round" }}
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            style={{ fillRule: "evenodd" }}
            d="M960 0c530.193 0 960 429.807 960 960s-429.807 960-960 960S0 1490.193 0 960 429.807 0 960 0Zm0 101.053c-474.384 0-858.947 384.563-858.947 858.947S485.616 1818.947 960 1818.947 1818.947 1434.384 1818.947 960 1434.384 101.053 960 101.053Zm-42.074 626.795c-85.075 39.632-157.432 107.975-229.844 207.898-10.327 14.249-10.744 22.907-.135 30.565 7.458 5.384 11.792 3.662 22.656-7.928 1.453-1.562 1.453-1.562 2.94-3.174 9.391-10.17 16.956-18.8 33.115-37.565 53.392-62.005 79.472-87.526 120.003-110.867 35.075-20.198 65.9 9.485 60.03 47.471-1.647 10.664-4.483 18.534-11.791 35.432-2.907 6.722-4.133 9.646-5.496 13.23-13.173 34.63-24.269 63.518-47.519 123.85l-1.112 2.886c-7.03 18.242-7.03 18.242-14.053 36.48-30.45 79.138-48.927 127.666-67.991 178.988l-1.118 3.008a10180.575 10180.575 0 0 0-10.189 27.469c-21.844 59.238-34.337 97.729-43.838 138.668-1.484 6.37-1.484 6.37-2.988 12.845-5.353 23.158-8.218 38.081-9.82 53.42-2.77 26.522-.543 48.24 7.792 66.493 9.432 20.655 29.697 35.43 52.819 38.786 38.518 5.592 75.683 5.194 107.515-2.048 17.914-4.073 35.638-9.405 53.03-15.942 50.352-18.932 98.861-48.472 145.846-87.52 41.11-34.26 80.008-76 120.788-127.872 3.555-4.492 3.555-4.492 7.098-8.976 12.318-15.707 18.352-25.908 20.605-36.683 2.45-11.698-7.439-23.554-15.343-19.587-3.907 1.96-7.993 6.018-14.22 13.872-4.454 5.715-6.875 8.77-9.298 11.514-9.671 10.95-19.883 22.157-30.947 33.998-18.241 19.513-36.775 38.608-63.656 65.789-13.69 13.844-30.908 25.947-49.42 35.046-29.63 14.559-56.358-3.792-53.148-36.635 2.118-21.681 7.37-44.096 15.224-65.767 17.156-47.367 31.183-85.659 62.216-170.048 13.459-36.6 19.27-52.41 26.528-72.201 21.518-58.652 38.696-105.868 55.04-151.425 20.19-56.275 31.596-98.224 36.877-141.543 3.987-32.673-5.103-63.922-25.834-85.405-22.986-23.816-55.68-34.787-96.399-34.305-45.053.535-97.607 15.256-145.963 37.783Zm308.381-388.422c-80.963-31.5-178.114 22.616-194.382 108.33-11.795 62.124 11.412 115.76 58.78 138.225 93.898 44.531 206.587-26.823 206.592-130.826.005-57.855-24.705-97.718-70.99-115.729Z"
          />{" "}
        </g>
      </svg>
    ),
    multiple_action_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M13.6431 0.22995L13.8549 0.172949C14.7141 -0.0286044 15.605 -0.0542117 16.4737 0.0972837L16.8441 0.172946C18.0875 0.464606 19.0816 1.39292 19.4691 2.64311L19.5261 2.855C19.7276 3.71419 19.7532 4.60494 19.5964 5.50205L19.5261 5.84406C19.2345 7.08745 18.3061 8.08157 17.0559 8.46907L16.8441 8.52607C15.9849 8.72762 15.094 8.75323 14.1969 8.59636L13.8549 8.52607C12.6115 8.23441 11.6174 7.30611 11.2299 6.05591L11.1729 5.84402C10.9424 4.86102 10.9424 3.838 11.1729 2.85496C11.4646 1.61157 12.3929 0.61745 13.6431 0.22995ZM16.4147 2.12625L16.1293 2.06752C15.5261 1.96232 14.9074 1.9801 14.345 2.1114L14.2013 2.14985C13.6613 2.31751 13.2488 2.75928 13.1192 3.31158C12.9592 3.99424 12.9592 4.7047 13.1106 5.35311L13.149 5.49682C13.3167 6.0368 13.7584 6.44932 14.2826 6.5727L14.568 6.63143C15.1713 6.73663 15.7899 6.71885 16.3523 6.58755L16.496 6.54909C17.036 6.38143 17.4485 5.93967 17.5719 5.41557L17.6306 5.13017C17.7358 4.52687 17.718 3.90826 17.5867 3.34583L17.5483 3.20213C17.3806 2.66215 16.9389 2.24963 16.4147 2.12625ZM2.85493 0.172947L2.64308 0.22995C1.39289 0.617444 0.464594 1.61155 0.172938 2.85494C-0.0576455 3.83798 -0.0576455 4.86104 0.172937 5.84407L0.229942 6.05593C0.617437 7.30612 1.61155 8.23442 2.85494 8.52608L3.19691 8.59636C4.09406 8.75323 4.98485 8.72762 5.84408 8.52607L6.05592 8.46907C7.30611 8.08158 8.23441 7.08747 8.52607 5.84408L8.59636 5.50211C8.75322 4.60495 8.72762 3.71416 8.52607 2.85494L8.46906 2.64309C8.08157 1.3929 7.08746 0.464602 5.84407 0.172945L5.47372 0.0972833C4.60495 -0.054211 3.71415 -0.0286046 2.85493 0.172947ZM5.1293 2.06752L5.41469 2.12625C5.93886 2.24963 6.38062 2.66214 6.54827 3.20214L6.58673 3.34585C6.71803 3.90829 6.73581 4.52685 6.63061 5.13012L6.57188 5.41551C6.4485 5.93968 6.03599 6.38144 5.49599 6.54909L5.35228 6.58755C4.78984 6.71885 4.17128 6.73663 3.56801 6.63143L3.28262 6.5727C2.75845 6.44932 2.31669 6.03681 2.14904 5.49681L2.11058 5.3531C1.95912 4.70468 1.95912 3.99426 2.11924 3.31164C2.24881 2.75927 2.66132 2.31751 3.20132 2.14986L3.34503 2.1114C3.90747 1.9801 4.52603 1.96232 5.1293 2.06752ZM2.85499 11.1729L2.6431 11.2299C1.39291 11.6174 0.464598 12.6115 0.172938 13.8549C-0.0576461 14.8379 -0.0576461 15.8611 0.172938 16.8441L0.229943 17.0559C0.617442 18.3061 1.61156 19.2345 2.85495 19.5261L3.19697 19.5964C4.09407 19.7532 4.98482 19.7276 5.84401 19.5261L6.05591 19.4691C7.3061 19.0816 8.23441 18.0875 8.52607 16.8441L8.59636 16.5021C8.75322 15.605 8.72762 14.7141 8.52606 13.8549L8.46906 13.6431C8.08156 12.3929 7.08744 11.4646 5.84405 11.1729L5.47367 11.0973C4.60493 10.9458 3.71418 10.9714 2.85499 11.1729ZM5.12935 13.0675L5.41475 13.1263C5.93885 13.2496 6.38062 13.6621 6.54827 14.2021L6.58673 14.3459C6.71803 14.9083 6.73581 15.5269 6.63061 16.1301L6.57188 16.4155C6.4485 16.9397 6.03598 17.3815 5.496 17.5491L5.35229 17.5876C4.78987 17.7188 4.17126 17.7366 3.56796 17.6314L3.28256 17.5727C2.75846 17.4493 2.31669 17.0368 2.14904 16.4968L2.11058 16.3531C1.95912 15.7047 1.95912 14.9942 2.11924 14.3116C2.24881 13.7593 2.66133 13.3175 3.20131 13.1498L3.34501 13.1114C3.90744 12.9801 4.52605 12.9624 5.12935 13.0675ZM13.855 11.1729L13.6431 11.2299C12.3929 11.6174 11.4646 12.6116 11.1729 13.855C10.9424 14.838 10.9424 15.8611 11.1729 16.844L11.2299 17.0559C11.6174 18.3061 12.6116 19.2345 13.855 19.5261L14.197 19.5964C15.0941 19.7532 15.9849 19.7276 16.844 19.5261L17.0559 19.4691C18.3061 19.0816 19.2344 18.0875 19.5261 16.8441L19.5964 16.5021C19.7532 15.605 19.7276 14.7142 19.5261 13.855L19.4691 13.6431C19.0816 12.3929 18.0874 11.4646 16.8441 11.1729L16.4737 11.0973C15.6049 10.9458 14.7142 10.9714 13.855 11.1729ZM16.1294 13.0675L16.4147 13.1262C16.9389 13.2496 17.3806 13.6621 17.5483 14.2021L17.5867 14.3458C17.718 14.9082 17.7358 15.5269 17.6306 16.1302L17.5719 16.4156C17.4485 16.9397 17.036 17.3815 16.496 17.5491L16.3523 17.5876C15.7899 17.7188 15.1713 17.7366 14.568 17.6314L14.2826 17.5727C13.7585 17.4493 13.3167 17.0368 13.149 16.4968L13.1106 16.3531C12.9592 15.7047 12.9592 14.9942 13.1192 14.3116C13.2488 13.7593 13.6613 13.3175 14.2013 13.1498L14.345 13.1114C14.9074 12.9801 15.5261 12.9624 16.1294 13.0675Z"
          fill="#563BFF"
        />
      </svg>
    )
  };
  return (
    <React.Fragment>
      <Row className="justify-content-between">
        <div className="section__title col-sm-auto font-primary">
          {props.t("Vue globale")}
          <span
            style={{ cursor: "pointer" }}
            onMouseEnter={() =>
              handleIconMouseEnter(15, props.t("Temps moyen de réponse"))
            }
            onMouseLeave={handleIconMouseLeave}
          >
            {svgs.info_icon}
          </span>
          {hoverText[0] === 15 && (
            <div
              className="hover-text-dashboard font-primary"
              style={{
                top: "20%",
                right: "",
                padding: "5px 10px",
                fontWeight: "400",
                transform: "translate(120%, -150%)"
              }}
            >
              {hoverText[1]}
            </div>
          )}
        </div>
      </Row>
      <Row
        style={{
          flex: "1"
        }}
      >
        {statsData && statsData.has("message_total") ? (
          Array.from(statsData.keys()).map((item_key, index) => (
            <Row
              key={index}
              className="d-flex align-items-center"
              style={{ marginBottom: index === 3 ? "20px" : "" }}
            >
              <div className="col-2 simple-text font-primary ">
                {props.t(getItemData(item_key, statsData).text)}
              </div>
              <div className="col-9">
                <div className="globale-bar__container d-flex">
                  <div
                    key={index}
                    style={{
                      backgroundColor: getItemData(item_key, statsData)
                        .backgroundColor,
                      width:
                        getItemData(item_key, statsData).width.toFixed(0) + "%",
                      whiteSpace: "nowrap"
                    }}
                    className="globale-bar"
                  ></div>
                </div>
              </div>
              <div
                className="col-1"
                style={{
                  color: getItemData(item_key, statsData).backgroundColor,
                  textAlign: "end",
                  paddingRight: "0"
                }}
              >
                {getItemData(item_key, statsData).width.toFixed(0)}%
              </div>
              {index !== 3 && <div className="divider"></div>}
            </Row>
          ))
        ) : (
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
              backgroundImage: "url(" + global_view + ")",
              height: "100%",
              width: "100%",
              backgroundSize: "110%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center"
            }}
          >
            <div className="font-primary font-size-22 color-black mt-5">
              {props.t("En attente de données")}
            </div>
            <img src={logo_maaia} alt="logo_maaia" height={40} />
          </div>
        )}
      </Row>
    </React.Fragment>
  );
};

export default withTranslation()(VueGlobale);
